/*LIBRARY*/

/*COMPONENT*/
import TextFieldGroup, { SelectField } from "../common_input/TextFieldGroup";

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import countries from "../../Data/countries.json";

/*CONST*/

const RegisterStep1 = ({ organization, onChange, errors, country }) => {
  const language = localStorage?.language ? localStorage?.language : "ina";

  const countries_list = countries.map((countryItem) => ({
    name: countryItem.name,
    title: countryItem.name,
  }));

  return (
    <>
      <TextFieldGroup
        Title={dict["Your organization name"][language]}
        placeholder={`${dict["Enter your organization name"][language]}`}
        name="organization"
        value={organization}
        onChange={onChange}
        error={errors?.organization}
      />
      <SelectField
        Title={dict["Where the organization operates"][language]}
        list_array={countries_list}
        id="country"
        name="country"
        value={country}
        onChange={onChange}
        error={errors?.country}
        placeholder={`${dict["Choose country"][language]}`}
      />
    </>
  );
};

export default RegisterStep1;
